module.exports = __webpack_public_path__ + "static/unrotated-b9dc2c6abc177874553d4f35d67bd9ea.png";